<script>
import MethodButtonBase from './MethodButtonBase';
import FiIdIcon from '../../assets/svg/fi-dvv-small.svg';
export default {
  name: 'IdCardButtonFi',
  components: {
    MethodButtonBase,
    FiIdIcon,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <FiIdIcon :class="$style.icon" />
    </template>
    <template v-slot:slot2>
      {{ $t('varmennekortti') }}
    </template>
  </MethodButtonBase>
</template>

<style lang="scss" module>
.icon {
  display: block;
  width: 17px;
  height: auto;
  margin-right: 8px;
}
</style>
